import { r as registerInstance, h, H as Host, g as getElement } from './index-16dc7dde.js';
import { f as favoriteButtonSizes } from './constants-3993c815.js';
import { p as pesIconSizes } from './constants-e9ddcc22.js';

const favoritesButtonCss = ":host(:not([dir=\"rtl\"])) button{padding-left:0}:host([dir=\"rtl\"]) button{padding-right:0}:host{display:flex;align-items:center;color:#42b4e6;outline:none;-webkit-user-select:none;user-select:none}:host(:hover){cursor:pointer}:host(:focus){outline:2px solid #007acd}:host(:focus:not(:focus-visible)){outline:0}:host(.favorites-button--size-sm){line-height:1rem;font-size:0.75rem}:host(.favorites-button--size-md){line-height:1.5rem;font-size:0.875rem}:host(.favorites-button--size-lg){line-height:1.875rem;font-size:1rem}.favorites-button__container{padding:0;display:flex;align-items:center;background:transparent;color:#42b4e6}.favorites-button__container,.favorites-button__container:active,.favorites-button__container:focus{border:none;outline:none}.favorites-button__container:hover{cursor:pointer}:host(:not([dir=\"rtl\"])) .favorites-button__icon{margin-right:4px}:host([dir=\"rtl\"]) .favorites-button__icon{margin-left:4px}.favorites-button__label{overflow:hidden;text-overflow:ellipsis}:host(.favorites-button--size-sm) .favorites-button__label{line-height:1rem;font-size:0.75rem}:host(.favorites-button--size-md) .favorites-button__label{line-height:1.5rem;font-size:0.875rem}:host(.favorites-button--size-lg) .favorites-button__label{line-height:1.875rem;font-size:1rem}";

let FavoritesButton = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.addIcon = 'star_stroke';
    this.removeIcon = 'star_plain';
    this.isInList = false;
    this.size = favoriteButtonSizes.MD;
    this.iconSizes = {
      [favoriteButtonSizes.SM]: pesIconSizes.MICRO,
      [favoriteButtonSizes.MD]: pesIconSizes.SMALL,
      [favoriteButtonSizes.LG]: pesIconSizes.MEDIUM,
    };
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    const label = this.isInList ? this.removeLabel : this.addLabel;
    const icon = this.isInList ? this.removeIcon : this.addIcon;
    return (h(Host, { tabindex: "0", role: "button", class: {
        'favorites-button': true,
        [`favorites-button--size-${this.size}`]: true,
      } }, h("button", { class: "favorites-button__container" }, h("pes-icon", { class: "favorites-button__icon", size: this.iconSizes[this.size] }, icon), h("span", { class: "favorites-button__label" }, label))));
  }
  get el() { return getElement(this); }
};
FavoritesButton.style = favoritesButtonCss;

export { FavoritesButton as pes_favorites_button };
